import React, { useRef } from "react";
import { InputNumber  } from "primereact/inputnumber";

const InputValorMonetario = ({
    valor,
    onChange : onChangeParent
}) => {
    // const { dispatchPrincipal } = useContext(GlobalContext);

    // const isMounted = useRef(false);
    // const [estadoControl, setForceUpdate] = useState(10);
    // const inputnumeral = useRef(null);
    const ultimoInputValido = useRef("");
    const ultimoSelectionStart = useRef("");
    const ultimoSelectionEnd = useRef("");

    return( <InputNumber 
                onChange={(e) => {                             
                    // console.log("---onChange--- InputNumerico Componente");
                    const inputEntrante = e.value;
                    
                    if(inputEntrante===null){
                        ultimoInputValido.current = "";
                        ultimoSelectionStart.current = "";
                        ultimoSelectionEnd.current = "";
                        onChangeParent({eOrigen: e, valor: null});
                        return;
                    }

                    const stringDecimalEntrante = inputEntrante.toFixed(2);
                    // if(!inputEntrante.match(/^S\/\s(([1-9]\d{0,8})|0)?(\.\d{2})?$/)){
                    if(!stringDecimalEntrante.match(/^(([1-9]\d{0,8})|0)(\.\d{2})$/)){
                    // if(!inputEntrante.match(/^S\/\s(([1-9]\d{0,8})|0)(\.\d{2})$/)){
                            
                        // console.log("valor: "+e.originalEvent.target.value);
                        e.originalEvent.target.value= ultimoInputValido.current;
                        e.originalEvent.target.selectionStart=ultimoSelectionStart.current;
                        e.originalEvent.target.selectionEnd=ultimoSelectionEnd.current;
                        return;
                    }

                    ultimoInputValido.current =  e.originalEvent.target.value;
                    ultimoSelectionStart.current = e.originalEvent.target.selectionStart;;
                    ultimoSelectionEnd.current = e.originalEvent.target.selectionEnd;;

                    onChangeParent({eOrigen: e, valor: stringDecimalEntrante});
                    
                }}
                value={valor}
                placeholder={"S/ 0.00"}
                minFractionDigits={2}
                maxFractionDigits={2}
                mode="currency" 
                currency="PEN"
                locale="es-PE"
                useGrouping={false}
                inputClassName="p-0 w-32 rounded-none block p-error"
            />                        
                );

};

export {InputValorMonetario};